import { i18n } from '@shared/i18n';
import _values from 'lodash/values';

class ProgramDays {
  static get values() {
    return {
      monday: 'monday',
      tuesday: 'tuesday',
      wednesday: 'wednesday',
      thursday: 'thursday',
      friday: 'friday',
      saturday: 'saturday',
      sunday: 'sunday',
    };
  }

  static labelOf(ProgramDayId) {
    if (!this.values[ProgramDayId]) {
      return ProgramDayId;
    }

    return i18n(`entities.program.days.${ProgramDayId}.label`);
  }

  static descriptionOf(ProgramDayId) {
    if (!this.values[ProgramDayId]) {
      return ProgramDayId;
    }

    return i18n(`entities.program.days.${ProgramDayId}.description`);
  }

  static get selectOptions() {
    return _values(this.values).map((value) => ({
      id: value,
      value: value,
      title: this.descriptionOf(value),
      label: this.labelOf(value),
    }));
  }
}

export default ProgramDays;
